import React, { useEffect } from 'react'
import { GiTreeBranch } from 'react-icons/gi';
import { toast } from 'react-toastify';
import { useAppStore, useBranchStore } from '../../stores';
const toastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};
const loadBranches = async ({ setState, setCurrentBranch }, cb) => {
    try {
        const res = await fetch("/api/admin/branches");
        const { branches, message } = (await res.json());
        if (res.status !== 200) {
            throw Error(message);
        }
        setState(branches);
        setCurrentBranch(branches[0]);
        console.log(branches);
    } catch (error) {
        toast.error(error.message, toastOptions);
    }
    finally {
        cb && cb();
    }
}

const SelectBranch = () => {
    const addAllBranches = useBranchStore(state => state.addAllBranches);
    const branches = useBranchStore(state => state.branches);
    const branchesLoading = useBranchStore(state => state.loading);
    const branchId = useBranchStore(state => state.branchId);
    const currentBranch = useBranchStore(state => state.currentBranch);
    const setCurrentBranch = useBranchStore(state => state.seCurrentBranch);
    const showLoading = useAppStore(state => state.showLoading);
    const hideLoading = useAppStore(state => state.hideLoading);
    const loading = useAppStore(state => state.loading);
    useEffect(() => {
        if (branchesLoading) {
            showLoading();
            loadBranches({ setState: addAllBranches, setCurrentBranch: setCurrentBranch }, () => hideLoading());
        }
    }, [branches, branchesLoading])
    return (
        <div className="p-2 m-0" style={{ width: "99%" }}>
            <div className='row mb-1 mt-1' style={{ justifyContent: "start" }}>
                <label htmlFor="branch" style={{ width: "max-content", display: "flex" }}>
                    <GiTreeBranch id="branchIconSelect" />
                    <h4>Branch</h4>
                </label>
                <select value={branchId} name="branch" className="form-select col-4 ms-1 branchSelect" placeholder="Select Degree" onChange={(e) => {
                    setCurrentBranch(branches.find(branch => branch._id === e.currentTarget.value));
                }}>
                    {branches.map((branch, index) => <option key={index} value={branch._id}>{branch.degree.name}- {branch.code.toUpperCase()}</option>)}
                </select>
            </div>
            <div className="line-break"></div>
        </div>
    )
}

export default SelectBranch